/**
 * MYD bottom-sheet drag-to-dismiss.
 * window.MYDSheetDrag.bind(sheet, { onClose, overlay?, handleSelector?, headerSelector?, scrollSelector? })
 */
(function () {
  if (window.MYDSheetDrag) return;

  var IGNORE =
    'button, a, input, label, select, textarea, option, [role="tab"], [role="radio"], [role="checkbox"], [role="option"], [data-myd-sc-size], .myd-search-qa__variant-btn, .myd-size-sheet__chip, .myd-size-sheet__option';

  function bind(sheet, options) {
    if (!sheet || sheet.__mydDragBound) return function () {};
    sheet.__mydDragBound = true;

    var onClose = options && options.onClose;
    var overlay = options && options.overlay;
    var handleSel =
      (options && options.handleSelector) ||
      '.myd-sc__grabber, .myd-sc__handle, .myd-search-qa__handle, .myd-size-sheet__handle, .myd-facet-sheet__handle, [data-myd-sheet-handle]';
    var headerSel =
      (options && options.headerSelector) ||
      '.myd-sc__header, .myd-search-qa__head, .myd-size-sheet__title, [data-myd-sheet-header]';
    var scrollSel = (options && options.scrollSelector) || null;

    var startY = 0;
    var lastY = 0;
    var lastT = 0;
    var velocity = 0;
    var dragging = false;
    var armed = false;
    var pointerId = null;
    var baseTransform = '';

    function scroller() {
      if (!scrollSel) return null;
      return sheet.querySelector(scrollSel);
    }

    function scrollTopOk() {
      var el = scroller();
      if (!el) {
        // Sheet itself may scroll (quick-add)
        return (sheet.scrollTop || 0) <= 0;
      }
      return (el.scrollTop || 0) <= 0;
    }

    function threshold() {
      return Math.min(160, Math.max(72, (sheet.offsetHeight || 400) * 0.2));
    }

    function setDrag(y, animate) {
      var dy = Math.max(0, y);
      if (animate) {
        sheet.style.transition = 'transform 0.28s cubic-bezier(0.32, 0.72, 0, 1)';
        if (overlay) overlay.style.transition = 'opacity 0.28s ease';
      } else {
        sheet.style.transition = 'none';
        if (overlay) overlay.style.transition = 'none';
      }
      if (dy <= 0) {
        sheet.style.transform = baseTransform || '';
      } else {
        sheet.style.transform = 'translate3d(0, ' + dy + 'px, 0)';
      }
      if (overlay) {
        var h = sheet.offsetHeight || 400;
        var progress = Math.min(1, dy / h);
        overlay.style.opacity = String(Math.max(0.12, 1 - progress * 0.85));
      }
    }

    function clearDragStyles() {
      sheet.style.transition = '';
      sheet.style.transform = '';
      sheet.classList.remove('is-dragging');
      if (overlay) {
        overlay.style.transition = '';
        overlay.style.opacity = '';
      }
    }

    function dismiss() {
      var h = sheet.offsetHeight || 400;
      setDrag(h + 48, true);
      sheet.classList.remove('is-dragging');
      var finished = false;
      var finish = function () {
        if (finished) return;
        finished = true;
        sheet.removeEventListener('transitionend', onEnd);
        // Close while still translated off-screen, then drop inline styles
        // so open-state CSS cannot flash the sheet back to 0.
        if (typeof onClose === 'function') onClose();
        requestAnimationFrame(function () {
          clearDragStyles();
        });
      };
      var onEnd = function (e) {
        if (e.target !== sheet || e.propertyName !== 'transform') return;
        finish();
      };
      sheet.addEventListener('transitionend', onEnd);
      setTimeout(finish, 340);
    }

    function canArm(target) {
      if (!target || !sheet.contains(target)) return false;
      if (target.closest && target.closest(handleSel)) return true;
      if (target.closest && target.closest(headerSel)) {
        // Don't start drag on the close control inside the header
        if (target.closest('button, a, [data-myd-sc-close], [data-myd-qa-close]')) return false;
        return true;
      }
      if (target.closest && target.closest(IGNORE)) return false;
      return scrollTopOk();
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (sheet.hidden || sheet.getAttribute('aria-hidden') === 'true') return;
      if (!canArm(e.target)) return;

      armed = true;
      dragging = false;
      pointerId = e.pointerId;
      startY = e.clientY;
      lastY = e.clientY;
      lastT = performance.now();
      velocity = 0;
      baseTransform = '';

      try {
        sheet.setPointerCapture(e.pointerId);
      } catch (err) {}
    }

    function onPointerMove(e) {
      if (!armed || e.pointerId !== pointerId) return;
      var dy = e.clientY - startY;
      var now = performance.now();
      var dt = Math.max(1, now - lastT);
      velocity = ((e.clientY - lastY) / dt) * 1000;
      lastY = e.clientY;
      lastT = now;

      if (!dragging) {
        if (dy < 8) return;
        // Upward or mostly horizontal — abort
        if (dy < 0) {
          armed = false;
          return;
        }
        if (!scrollTopOk() && !(e.target && e.target.closest && e.target.closest(handleSel))) {
          armed = false;
          return;
        }
        dragging = true;
        sheet.classList.add('is-dragging');
      }

      if (dragging) {
        if (e.cancelable) e.preventDefault();
        setDrag(dy, false);
      }
    }

    function onPointerUp(e) {
      if (!armed || e.pointerId !== pointerId) return;
      armed = false;
      pointerId = null;
      try {
        sheet.releasePointerCapture(e.pointerId);
      } catch (err) {}

      if (!dragging) return;
      dragging = false;

      var dy = Math.max(0, e.clientY - startY);
      var shouldClose = dy > threshold() || velocity > 900;
      if (shouldClose) {
        dismiss();
      } else {
        setDrag(0, true);
        sheet.classList.remove('is-dragging');
        setTimeout(clearDragStyles, 300);
      }
    }

    function onPointerCancel(e) {
      if (!armed || (pointerId != null && e.pointerId !== pointerId)) return;
      armed = false;
      dragging = false;
      pointerId = null;
      setDrag(0, true);
      setTimeout(clearDragStyles, 300);
    }

    sheet.addEventListener('pointerdown', onPointerDown, { passive: true });
    sheet.addEventListener('pointermove', onPointerMove, { passive: false });
    sheet.addEventListener('pointerup', onPointerUp, { passive: true });
    sheet.addEventListener('pointercancel', onPointerCancel, { passive: true });

    return function unbind() {
      sheet.removeEventListener('pointerdown', onPointerDown);
      sheet.removeEventListener('pointermove', onPointerMove);
      sheet.removeEventListener('pointerup', onPointerUp);
      sheet.removeEventListener('pointercancel', onPointerCancel);
      sheet.__mydDragBound = false;
      clearDragStyles();
    };
  }

  window.MYDSheetDrag = { bind: bind };
})();
